import React, { useRef } from 'react';
import { Helmet } from 'react-helmet';
import { Navbar } from '../components/landing/Navbar';
import { HeroSection } from '../components/landing/HeroSection';
import { ProductShowcase } from '../components/landing/ProductShowcase';
import { Testimonials } from '../components/landing/Testimonials';
import { ClassRegistration } from '../components/landing/ClassRegistration';
import { FAQ } from '../components/landing/FAQ';
import { InstagramFeed } from '../components/landing/InstagramFeed';
import { ContactSection } from '../components/landing/ContactSection';
import { Footer } from '../components/landing/Footer';

export const LandingPage = () => {
  const productsRef = useRef(null);
  const classRef = useRef(null);
  const contactRef = useRef(null);

  const scrollToSection = (sectionId) => {
    let element;
    switch (sectionId) {
      case 'products':
        element = productsRef.current;
        break;
      case 'class':
        element = classRef.current;
        break;
      case 'contact':
        element = contactRef.current;
        break;
      default:
        element = null;
    }
    
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Keratin Straightener - Perfect Pass | Winamor Australia</title>
        <meta name="description" content="Australia's best keratin iron with pass counting technology. The Winamor Perfect Pass counts your passes for you - perfect results every time. Professional hair straightener for keratin treatments. Shop now $310." />
        <meta name="keywords" content="keratin iron, best straightener for keratin, keratin hair straightener, professional keratin iron Australia, Winamor Perfect Pass, pass counting straightener, keratin treatment tools" />
        
        {/* Open Graph */}
        <meta property="og:title" content="Winamor Perfect Pass - Australia's Best Keratin Iron" />
        <meta property="og:description" content="The Winamor Perfect Pass counts your passes for you. Australia's first keratin iron with built-in pass counting technology. Perfect keratin results every time." />
        <meta property="og:image" content="https://customer-assets.emergentagent.com/job_smart-iron-funnel/artifacts/awleu9gc_DSC04270.jpg" />
        <meta property="og:type" content="product" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Winamor Perfect Pass - Best Keratin Iron Australia" />
        <meta name="twitter:description" content="Australia's first keratin iron with pass counting technology. Perfect results every time." />
        
        {/* Canonical */}
        <link rel="canonical" href="https://www.winamor.com.au" />
      </Helmet>

      <div className="min-h-screen bg-[#0F0720]" data-testid="landing-page">
        <Navbar onNavigate={scrollToSection} />
        
        <main>
          {/* Hero - SEO H1 */}
          <HeroSection onScrollToProducts={() => scrollToSection('products')} />
          
          {/* Products - SEO H2 */}
          <div ref={productsRef}>
            <ProductShowcase id="products" />
          </div>
          
          {/* Testimonials with Video */}
          <Testimonials />
          
          {/* Masterclass Registration */}
          <div ref={classRef}>
            <ClassRegistration id="class" />
          </div>
          
          {/* FAQ - SEO Rich Content */}
          <FAQ />
          
          {/* Instagram Feed - Social Proof */}
          <InstagramFeed />
          
          {/* Contact */}
          <div ref={contactRef}>
            <ContactSection id="contact" />
          </div>
        </main>
        
        <Footer />
      </div>
    </>
  );
};

export default LandingPage;
